// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
import LicencePlateFlag from '../../common/LicencePlateFlag/LicencePlateFlag'

const CantonSelect = (props: IElementProps) => {
  const { t, i18n } = useTranslation('common')

  const [searchString, setSearchString] = useState('')
  const [showCantons, setShowCantons] = useState([])
  const [plateNumber, setPlateNumber] = useState(props.value ? props.value.slice(2, props.value.length) : '')
  const [plateCanton, setPlateCanton] = useState(props.value ? props.value.slice(0, 2) : '')
  const [showAllCantons, setShowAllCantons] = useState(false)

  const defaultExternalData: IExternalDataItem = props.externalDataDict['cantons'] || null
  const optionsToRender = defaultExternalData?.data
    ? Object.keys(defaultExternalData?.data).map((key) => ({
        name: key,
        value: defaultExternalData.data[key],
        tr: defaultExternalData.tr ? defaultExternalData.tr[key] : {},
      }))
    : []

  useEffect(() => {
    if (!props.value) {
      setPlateNumber('')
      setPlateCanton('')
    }
  }, [props.value])

  useEffect(() => {
    if (props?.externalDataSourceName === 'cantonFromLocation' && !!props.externalData?.data) {
      const externalValue = props.externalData.data[Object.keys(props.externalData.data)[0]]

      const e = {
        target: {
          value: externalValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      // setTimeout(() => {
      props.handleChange(props.name, e)
      // }, props.index * 10)
    }
  }, [props.externalData])

  useEffect(() => {
    if (searchString.length >= 2) {
      const found = optionsToRender.filter(
        (c) =>
          `${c.name} ${
            c.tr
              ? Object.keys(c.tr)
                  .map((k) => c.tr[k])
                  .join(' ')
              : ''
          }`
            .toLowerCase()
            .indexOf(searchString) > -1
      )
      setShowCantons(found)
    } else {
      setShowCantons([])
      if (showAllCantons) {
        setShowCantons(optionsToRender)
      }
    }
  }, [searchString, i18n.language])

  function searchChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setSearchString(e.target.value.toLowerCase())
  }

  function selectCanton(el: any) {
    const value = el.value || el
    const e = {
      target: {
        value: value,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)

    setPlateCanton(value.slice(0, 2))
    setShowCantons([])
    setShowAllCantons(false)
    setSearchString('')
  }

  function removeCanton() {
    const e = {
      target: {
        value: '',
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setPlateCanton('')
    setPlateNumber('')
    setShowCantons([])
    setShowAllCantons(false)
    setSearchString('')
  }

  const cantonsRef = useRef(null)

  function handleDocumentClick(e: Event) {
    if (cantonsRef?.current?.contains(e?.target)) {
      return
    } else {
      toggleCantonsList(true)
    }
  }

  function toggleCantonsList(close?: boolean) {
    const newState = close ? false : !showAllCantons
    const eventName = 'mousedown'
    if (!(props.formReadOnly || props.disabledInput)) {
      if (newState) {
        document.addEventListener(eventName, handleDocumentClick, false)
        setShowCantons(optionsToRender)
      } else {
        document.removeEventListener(eventName, handleDocumentClick, false)
        setShowCantons([])
        setSearchString('')
      }
      setShowAllCantons(newState)
    }
  }
  useEffect(() => {
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick, false)
    }
  }, [])

  function applyPlateNumber(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value || ''
    if (plateNumber?.length === 7 && value?.length >= 7) {
      return
    }
    setPlateNumber(value)
    const formValue = `${plateCanton + value}`
    selectCanton(formValue)
  }

  return (
    <>
      {props.visible && (
        <div style={{ position: 'relative' }} className="formGroup marginB0" ref={cantonsRef}>
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="flex between">
            <div className="selectArea" style={{ width: props.platesRequired ? 'calc(100% - 150px)' : '100%' }}>
              <input
                name={`fieldnameveryunique${new Date().getTime()}`}
                key={props.name}
                readOnly={props.formReadOnly || props.disabledInput}
                type="text"
                autoComplete="none"
                list="autocompleteOff"
                value={searchString}
                className="required-highlight transparent"
                onChange={(e) => searchChanged(e)}
                onClick={() => toggleCantonsList()}
              />
              {props.value?.length > 0 &&
                !showAllCantons &&
                optionsToRender
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(
                    (el) =>
                      el.value === props.value.slice(0, 2) && (
                        <div className="cantonsOptionInInput">
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <img src={`../../../../../kantons/${el.value}.svg`} width="12" height="14" />
                            {el.tr[i18n.language] || el.name}
                          </div>
                          {!(props.formReadOnly || props.disabledInput) && (
                            <i onClick={() => removeCanton()} className="icon-clear" />
                          )}
                        </div>
                      )
                  )}
              <div className="cantonsOptionArea">
                {showCantons
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((el) => (
                    <a className="cantonsOption" onClick={() => selectCanton(el)}>
                      <img src={`../../../../../kantons/${el.value}.svg`} width="12" height="14" />
                      {el.tr[i18n.language] || el.name}
                    </a>
                  ))}
              </div>
              <i className="icon-bottom" />
            </div>
            {props.platesRequired && plateCanton && (
              <LicencePlateFlag
                countryCode="CH"
                licenceNumber={plateCanton + plateNumber}
                width="12"
                height="14"
                formView={true}
              />
            )}
          </div>
          {props.platesRequired && !!props.value && (
            <>
              <label style={{ gridGap: '0' }}>{t('ENTER_PLATE_NUMBER')}</label>
              <div className="flex between marginB0">
                <span style={{ width: 'calc(100% - 261px' }}>
                  <input
                    name={`fieldnameveryunique${new Date().getTime()}`}
                    autoComplete="none"
                    list="autocompleteOff"
                    value={plateNumber}
                    readOnly={props.formReadOnly || props.disabledInput}
                    disabled={props.value ? false : true}
                    style={{ width: '100%', textTransform: 'uppercase' }}
                    type="text"
                    onChange={(e) => applyPlateNumber(e)}
                  />
                </span>

                {plateNumber.match(/[a-zA-Z]/g) && (
                  <div className="text-warning">
                    {' '}
                    <i className="icon-warning" /> {t('PLATE_NUMBER_INCLUDES_LETTERS')}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}
export default CantonSelect
